/*
 * Fichier Javascript général pour Quantalys
 */

define(function (require) {

    var $ = require("jquery");
	require("bootstrap"); //pour initPopoverError
	var Tooltip = require("tooltip"); //https://popper.js.org/tooltip-examples.html
	var exports = {};


    $(document).ready(function () {
        initAlerteBootstrap();
        initPopoverError();
        initTooltips();
    });

    /**
     * Initialise les alertes bootstrap avec button dismissible, pouvant être réaffichées.
     */
    function initAlerteBootstrap() {
        $("[data-alert-hide]").click(function () {
            $(this).closest(".alert").addClass("hidden");
        });
    }

    /**
     * Initialise les popover de non access
     */
    function initPopoverError() {
        $('[data-error-access]').popover();
    }

    /**
     * Initialise les tooltips
     */
	function initTooltips() {
		$('[data-helper-explanation]').each(function (index, elt) {
			$elt = $(elt);

			//Si on a besoin d'initialiser des tooltips ajoutées après le chargement de la page, il faut utiliser le selecteur "[data-helper-explanation]:not([data-tooltip-isInit])" pour éviter de réinit celles déjà dans la page
			$elt.attr("data-tooltip-isInit", true);

			//Le texte est stocké dans l'attribut "data-content", généré par le helper Html.Tooltip()
			var content = $elt.attr("data-content");

			new Tooltip($elt, {
				title: content,
				html : "true",
				arrowSelector: ".popper-arrow",
				innerSelector: ".popper-inner",
				container: "body", //nécessaire pour que la tooltip s'adapte à la largeur du content
				trigger : "hover focus click",
				template: '<div class="popper" role="tooltip"><div class="popper-arrow"></div><div class="popper-inner"></div></div>'
			});
		});
	}

	exports.initTooltips = initTooltips;

	return exports;
});
